import gettext from '@sdk/lang/gettext';
import Column from '@sdk/components/ui/spacing/Column';
import { ClockInTime } from '@sdk/timeClock/utils/getActualClockInTimes';
import { Shift } from '@sdk/automatedBreaks/types/Shift';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import ClockInSummary from '@web/timeClock/modals/rows/ActualRow/ClockInSummary';
import { useActualRow } from '@web/timeClock/modals/rows/ActualRow/actualRow.hooks';
import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';

type Props = {
  shift: Shift;
  clockInTimes: ClockInTime[];
  clockInTimesBefore?: ClockInTime[];
};
const ActualRow = ({ shift, clockInTimes, clockInTimesBefore = [] }: Props) => {
  const {
    entriesBySequenceId,
    usTimeFormat,
    worldClockEnabled,
    areAutomatedBreaksUsed,
    clockInTimesOnlyBefore,
    clockInTimesBeforeByBaseSequenceIdMap,
    entriesBeforeBySequenceId,
  } = useActualRow(shift, clockInTimesBefore);

  return (
    <ModalRow label={gettext('Actual')} icon={TimeIconSvg}>
      <Column>
        {clockInTimes.map((clockInTime, index) => (
          <ClockInSummary
            key={index}
            timesheetEntries={entriesBySequenceId[clockInTime.baseSequenceId]}
            timesheetEntriesBefore={entriesBeforeBySequenceId[clockInTime.baseSequenceId] || []}
            breakAttestations={shift.timesheetProjections[index]?.breakAttestations || []}
            clockInTime={clockInTime}
            clockInTimeBefore={clockInTimesBeforeByBaseSequenceIdMap[clockInTime.baseSequenceId]}
            usTimeFormat={usTimeFormat}
            isLast={index === clockInTimes.length - 1}
            areAutomatedBreaksUsed={areAutomatedBreaksUsed}
            worldClockEnabled={worldClockEnabled}
          />
        ))}
        {clockInTimesOnlyBefore.map((clockInTimeBefore, index) => (
          <ClockInSummary
            key={index}
            timesheetEntriesBefore={
              entriesBeforeBySequenceId[clockInTimeBefore.baseSequenceId] || []
            }
            breakAttestations={shift.timesheetProjections[index]?.breakAttestations || []}
            clockInTimeBefore={clockInTimeBefore}
            usTimeFormat={usTimeFormat}
            isLast={index === clockInTimesOnlyBefore.length - 1}
            areAutomatedBreaksUsed={areAutomatedBreaksUsed}
            worldClockEnabled={worldClockEnabled}
          />
        ))}
      </Column>
    </ModalRow>
  );
};

export default ActualRow;
